import React, { useEffect, useState } from 'react';
import '../styles/EventsStyle.css';
import moment from 'moment';
import { BiChevronRightCircle, BiFilter, BiFilterAlt } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../settings';
import { displaySnackbar } from '../utilities';
const ping_audio = new Audio(require('../sound/ping.mp3'));

export default function Events({ events, alumniData, fetchEvents }) {
    const navigate = useNavigate();
    const [selectedFilter, setSelectedFilter] = useState('All');

    useEffect(() => {
        fetchEvents();
    }, []);

    useEffect(() => {
        fetchEvents();
    }, [selectedFilter]);

    // handler to remove subscribers from
    const remove_OldEvent = (the_event) => {
        fetch(`${BASE_URL}/events/update`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...the_event,
                id: the_event?.uuid,
                subscribers: Number(the_event.subscribers) + 1,
                subscribersList: [],
            }),
        })
            .then(async (result) => {
                let response = await result?.json();
                if (response?.msg === null) {
                    displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                } else {
                    fetchEvents();
                    displaySnackbar(response?.msg, false, 'Ok', () => {});
                }
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                } else {
                    displaySnackbar('Some error occured!', true, 'Ok', () => {});
                    console.log('the error:', error);
                }
            });
    };

    const filterd_events = events.filter((item) => {
        // if (new Date(item?.endDate).getDate() < new Date().getDate()) {
        //     remove_OldEvent(item);
        // }
        if (selectedFilter === 'overdue') {
            return new Date().getTime() > new Date(item?.endDate).getTime();
        } else if (selectedFilter === 'Today') {
            return moment(new Date(item?.startDate)).calendar().includes('Today');
        } else if (selectedFilter === 'later')
            return new Date(item?.startDate).getDate() > new Date().getDate();
        else if (selectedFilter === 'In Progress') {
            return (
                new Date(item?.startDate).getDate() < new Date().getDate() &&
                new Date(item?.endDate).getDate() > new Date().getDate()
            );
        } else return true;
    });

    // 👇️ handler to check if alumni is signed up for event
    const checkAlumniEventSignupStatus = (alumni, target_event) => {
        let existing_subscribers = JSON.parse(target_event?.subscribersList);
        if (existing_subscribers) {
            existing_subscribers = [...existing_subscribers];
            if (existing_subscribers) {
                let foundIndex = existing_subscribers.findIndex(
                    (item) => item?.uuid === alumni?.uuid
                );
                return foundIndex >= 0;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    // handler to play the ping_bell sound.
    const play_bellSound = () => {
        ping_audio.play();
        setTimeout(() => {
            ping_audio.pause();
        }, 1000);
    };

    // handler to update an alumni
    const updateAlumni = (the_event) => {
        let existing_subscriptions = alumniData?.subscriptionsList;
        console.log('alumniData?.subscriptionsList:', existing_subscriptions);

        if (existing_subscriptions) {
            existing_subscriptions = [...JSON.parse(existing_subscriptions)];
            if (Array.isArray(existing_subscriptions)) {
                fetch(`${BASE_URL}/alumni/update`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        ...alumniData,
                        id: alumniData?.uuid,
                        subscriptionsList: [
                            ...existing_subscriptions,
                            {
                                uuid: the_event?.uuid,
                            },
                        ],
                    }),
                })
                    .then(async (result) => {
                        let response = await result.json();
                        if (response?.errorMsg) {
                            displaySnackbar(response?.errorMsg, true);
                        } else {
                            // displaySnackbar(response?.msg, false);
                        }
                    })
                    .catch((error) => {
                        if (error?.message == 'Failed to fetch') {
                            displaySnackbar('Could not reach the servers', true);
                        } else {
                            console.log(error);
                            displaySnackbar('Could not update alumni.', true);
                        }
                    });
            } else {
                fetch(`${BASE_URL}/alumni/update`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        ...alumniData,
                        id: alumniData?.uuid,
                        subscriptionsList: [
                            {
                                uuid: the_event?.uuid,
                            },
                        ],
                    }),
                })
                    .then(async (result) => {
                        let response = await result.json();
                        if (response?.errorMsg) {
                            displaySnackbar(response?.errorMsg, true);
                        } else {
                            // displaySnackbar(response?.msg, false);
                        }
                    })
                    .catch((error) => {
                        if (error?.message == 'Failed to fetch') {
                            displaySnackbar('Could not reach the servers', true);
                        } else {
                            console.log(error);
                            displaySnackbar('Could not update alumni.', true);
                        }
                    });
            }
        } else {
            fetch(`${BASE_URL}/alumni/update`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...alumniData,
                    id: alumniData?.uuid,
                    subscriptionsList: [
                        {
                            uuid: the_event?.uuid,
                        },
                    ],
                }),
            })
                .then(async (result) => {
                    let response = await result.json();
                    if (response?.errorMsg) {
                        displaySnackbar(response?.errorMsg, true);
                    } else {
                        // displaySnackbar(response?.msg, false);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true);
                    } else {
                        console.log(error);
                        displaySnackbar('Could not update alumni.', true);
                    }
                });
        }
    };

    // handler to update an event
    const updateEvent = (the_event) => {
        // let existing_subscribers = JSON.parse(the_event?.subscribersList)
        let existing_subscribers = JSON.parse(the_event?.subscribersList);

        if (existing_subscribers) {
            existing_subscribers = [...existing_subscribers];
            if (existing_subscribers) {
                let foundIndex = existing_subscribers?.findIndex(
                    (item) => item?.uuid === alumniData?.uuid
                );
                if (foundIndex < 0) {
                    if (the_event?.subscribersList) {
                        fetch(`${BASE_URL}/events/update`, {
                            method: 'PATCH',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                ...the_event,
                                id: the_event?.uuid,
                                subscribers: Number(the_event.subscribers) + 1,
                                subscribersList: [
                                    ...JSON.parse(the_event?.subscribersList),
                                    {
                                        uuid: alumniData?.uuid,
                                        ...alumniData,
                                    },
                                ],
                            }),
                        })
                            .then(async (result) => {
                                let response = await result?.json();
                                if (response?.msg === null) {
                                    displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                                } else {
                                    fetchEvents();
                                    displaySnackbar(response?.msg, false, 'Ok', () => {});
                                }
                            })
                            .catch((error) => {
                                if (error?.message == 'Failed to fetch') {
                                    displaySnackbar(
                                        'Could not reach the servers',
                                        true,
                                        'Ok',
                                        () => {}
                                    );
                                } else {
                                    displaySnackbar('Some error occured!', true, 'Ok', () => {});
                                    console.log('the error:', error);
                                }
                            });
                    } else {
                        fetch(`${BASE_URL}/events/update`, {
                            method: 'PATCH',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                ...the_event,
                                id: the_event?.uuid,
                                subscribers: Number(the_event.subscribers) + 1,
                                subscribersList: [
                                    {
                                        uuid: alumniData?.uuid,
                                        ...alumniData,
                                    },
                                ],
                            }),
                        })
                            .then(async (result) => {
                                let response = await result?.json();
                                if (response?.msg === null) {
                                    displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                                } else {
                                    console.log(response);
                                    displaySnackbar(response?.msg, false, 'Ok', () => {});
                                    fetchEvents();
                                }
                            })
                            .catch((error) => {
                                if (error?.message == 'Failed to fetch') {
                                    displaySnackbar(
                                        'Could not reach the servers',
                                        true,
                                        'Ok',
                                        () => {}
                                    );
                                } else {
                                    displaySnackbar('Some error occured!', true, 'Ok', () => {});
                                    console.log('the error:', error);
                                }
                            });
                    }
                } else {
                    displaySnackbar("you're signed up already for this event.", false);
                }
            }
        } else {
            fetch(`${BASE_URL}/events/update`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...the_event,
                    id: the_event?.uuid,
                    subscribers: Number(the_event.subscribers) + 1,
                    subscribersList: [
                        {
                            uuid: alumniData?.uuid,
                            ...alumniData,
                        },
                    ],
                }),
            })
                .then(async (result) => {
                    let response = await result?.json();
                    if (response?.msg === null) {
                        displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                    } else {
                        console.log(response);
                        displaySnackbar(response?.msg, false, 'Ok', () => {});
                        fetchEvents();
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                    } else {
                        displaySnackbar('Some error occured!', true, 'Ok', () => {});
                        console.log('the error:', error);
                    }
                });
        }
    };

    // 👇️ handler to sign up an alumni for an event
    const signUp_alumni_forEvent = (the_event) => {
        // updateAlumni(the_event);
        updateEvent(the_event);
        play_bellSound();
    };

    return (
        <div className='events'>
            {/* <h1 className='headerText'>Events</h1> */}

            <div className='events-filter-container'>
                <button
                    style={{
                        backgroundColor: selectedFilter === 'All' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'All' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('All')}
                >
                    <span>All {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    style={{
                        backgroundColor: selectedFilter === 'overdue' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'overdue' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('overdue')}
                >
                    <span>Overdue {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    style={{
                        backgroundColor: selectedFilter === 'Today' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'Today' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('Today')}
                >
                    <span>Today {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    style={{
                        backgroundColor:
                            selectedFilter === 'In Progress' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'In Progress' ? '#eee' : '#333',
                    }}
                    onClick={() => setSelectedFilter('In Progress')}
                >
                    <span>In Progress {<BiFilterAlt size={25} />}</span>
                </button>
                <button
                    onClick={() => setSelectedFilter('later')}
                    style={{
                        backgroundColor: selectedFilter === 'later' ? 'darkblue' : 'transparent',
                        color: selectedFilter === 'later' ? '#eee' : '#333',
                    }}
                >
                    <span>Later {<BiFilterAlt size={25} />}</span>
                </button>
            </div>

            {filterd_events.length <= 0 ? (
                <div className='empty-events-container'>
                    <p className='events-empty-text'>No {selectedFilter} Events</p>

                    <div
                        xyz='fade large duration-20  iterate-infinite'
                        className='events-emptyEmojisDiv'
                    >
                        <p className='events-emptyEmojis xyz-nested'>📆</p>
                    </div>
                </div>
            ) : (
                <div className='events-list'>
                    {filterd_events.map((item, index) => (
                        <div
                            key={`event-item #${index}`}
                            className='event-item'
                            style={{ borderLeft: `.5rem solid ${item?.color}` }}
                        >
                            <div className='left'>
                                <p
                                    className='event-item-name'
                                    style={{ backgroundColor: item.color }}
                                    onClick={() => navigate(`/info/eventDetail/${item?.uuid}`)}
                                >
                                    {item.name}
                                    <BiChevronRightCircle size={30} className='icon' />
                                </p>
                                <p className='event-item-startDate'>
                                    starting: (
                                    {new Date(item?.startDate).toISOString().slice(0, 10)}){' '}
                                    {moment(new Date(item?.startDate)).fromNow()}
                                </p>
                                <p className='event-item-endDate'>
                                    ending: ({new Date(item?.endDate).toISOString().slice(0, 10)}){' '}
                                    {moment(new Date(item?.endDate)).fromNow()}{' '}
                                </p>

                                {new Date(item?.endDate).getTime() > new Date().getTime() && (
                                    <p className='event-item-subscribers'>
                                        subscribers: {item?.subscribers}
                                    </p>
                                )}

                                {new Date(item?.endDate).getTime() > new Date().getTime() &&
                                    (checkAlumniEventSignupStatus(alumniData, item) ? (
                                        <p className='message'>
                                            You're Signed Up for this event ✅
                                        </p>
                                    ) : (
                                        <button onClick={() => signUp_alumni_forEvent(item)}>
                                            Sign Up for event.
                                        </button>
                                    ))}
                            </div>
                            <div className='right'></div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
